export default {
	getLogin(state) {
		return typeof state.key === 'string' && state.key !== ''
	},
	getToken(state) {
		return state.key
	},
	getUserId(state) {
		return state.userid
	},
	getAdmin(state) {
		return state.admin
	},
	getUserType(state) {
		return state.user_type
	},
	getTokenHeader(state) {
		return { headers: { Authorization: state.key } }
	},
	getServer(state) {
		return state.server
	},
	getConsumer(state) {
		return (api) => state.consumers.find((consumer) => consumer.api === api)
	},
	getMyConsumers(state) {
		return state.consumers
	},
	getProduct(state) {
		return state.shop_product
	},
	getColor(state) {
		return state.color
	},
	getColorLow(state) {
		return state.color_low
	},
	getShopOndemand(state) {
		return state.shop_ondemand
	}
}
